const MARK_PATHS = [
  "M18.8595 19.9726C19.6915 20.0691 20.5308 20.0691 21.3553 19.9726C22.581 19.8314 23.554 18.8658 23.6952 17.6327C23.7917 16.8008 23.7917 15.9614 23.6952 15.1369C23.554 13.9113 22.5884 12.9382 21.3553 12.7971C20.5234 12.7005 19.684 12.7005 18.8595 12.7971C17.6339 12.9382 16.6608 13.9039 16.5197 15.1369C16.4231 15.9689 16.4231 16.8082 16.5197 17.6327C16.6608 18.8584 17.6265 19.8314 18.8595 19.9726Z",
  "M27.09 19.9726C27.9219 20.0691 28.7613 20.0691 29.5858 19.9726C30.8114 19.8314 31.7845 18.8658 31.9256 17.6327C32.0222 16.8008 32.0222 15.9614 31.9256 15.1369C31.7845 13.9113 30.8189 12.9382 29.5858 12.7971C28.7539 12.7005 27.9145 12.7005 27.09 12.7971C25.8644 12.9382 24.8913 13.9039 24.7502 15.1369C24.6536 15.9689 24.6536 16.8082 24.7502 17.6327C24.8913 18.8584 25.8569 19.8314 27.09 19.9726Z",
  "M18.8595 28.2029C19.6915 28.2994 20.5308 28.2994 21.3553 28.2029C22.581 28.0617 23.554 27.0961 23.6952 25.863C23.7917 25.0311 23.7917 24.1917 23.6952 23.3672C23.554 22.1416 22.5884 21.1685 21.3553 21.0274C20.5234 20.9308 19.684 20.9308 18.8595 21.0274C17.6339 21.1685 16.6608 22.1342 16.5197 23.3672C16.4231 24.1992 16.4231 25.0385 16.5197 25.863C16.6608 27.0887 17.6265 28.0617 18.8595 28.2029Z",
  "M10.6369 19.9726C11.4688 20.0692 12.3082 20.0692 13.1327 19.9726C14.3583 19.8315 15.3314 18.8658 15.4725 17.6328C15.5691 16.8008 15.5691 15.9615 15.4725 15.137C15.3314 13.9113 14.3657 12.9383 13.1327 12.7971C12.3007 12.7006 11.4614 12.7006 10.6369 12.7971C9.41124 12.9383 8.43817 13.9039 8.29703 15.137C8.20047 15.9689 8.20047 16.8083 8.29703 17.6328C8.43817 18.8584 9.40381 19.8315 10.6369 19.9726Z",
  "M2.4064 19.9726C3.23834 20.0692 4.07771 20.0692 4.90222 19.9726C6.12785 19.8315 7.10092 18.8658 7.24205 17.6328C7.33862 16.8008 7.33862 15.9615 7.24205 15.137C7.10092 13.9113 6.13527 12.9383 4.90222 12.7971C4.07028 12.7006 3.23091 12.7006 2.4064 12.7971C1.18077 12.9383 0.207697 13.9039 0.066564 15.137C-0.0300005 15.9689 -0.0300005 16.8083 0.066564 17.6328C0.207697 18.8584 1.17334 19.8315 2.4064 19.9726Z",
  "M10.6369 11.7423C11.4688 11.8389 12.3082 11.8389 13.1327 11.7423C14.3583 11.6012 15.3314 10.6355 15.4725 9.40249C15.5691 8.57055 15.5691 7.73118 15.4725 6.90667C15.3314 5.68104 14.3657 4.70797 13.1327 4.56684C12.3007 4.47027 11.4614 4.47027 10.6369 4.56684C9.41124 4.70797 8.43817 5.67362 8.29703 6.90667C8.20047 7.73861 8.20047 8.57798 8.29703 9.40249C8.43817 10.6281 9.40381 11.6012 10.6369 11.7423Z",
];

export type UnboxMarkMotion = "still" | "spin" | "intro";

/** The Unbox mark. "spin" turns while something is loading; "intro" pops each dot in once. */
export function UnboxMark({
  size = 20,
  motion = "still",
  className = "",
}: {
  size?: number;
  motion?: UnboxMarkMotion;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className={`unbox-mark unbox-mark--${motion} ${className}`}
    >
      <g transform="translate(0 -0.5)">
        {MARK_PATHS.map((d, i) => (
          <path key={d} d={d} fill="currentColor" style={{ animationDelay: `${i * 90}ms` }} />
        ))}
      </g>
    </svg>
  );
}
